var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('transition',{attrs:{"enter-active-class":_vm.$store.state.enterClassName,"leave-active-class":_vm.$store.state.leaveClassName}},[_c('keep-alive',[_c('router-view',{on:{"loaded":_vm.loaded}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }